import { Chip } from 'primereact/chip';
import { chatFiltersNames } from './chat-filter-constant'; 
import "./style.css";

const ChatFilter = (props) =>{
    const {filter,onClick} = props
return (
    <div className='flex gap-3 px-2 py-1 chat-filter-container'>
        {
            chatFiltersNames?.map(item => <Chip key={item.value} label={item.label} onClick={()=>onClick(item.value)} className={`cursor-pointer ${filter === item.value && "selected-filter"}`}/>)
        }
    </div>

)
}

export default ChatFilter;